module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/spa-0aeb4c400449ea9c6bba197b7a18f2d4.png";